import {Component, OnInit, ViewChild} from '@angular/core';
import { MatDialog} from '@angular/material/dialog';
import { MatTableDataSource } from '@angular/material/table';
import {SnackBarIconService} from '../shared/snack-bar-icon/snack-bar-icon.service';
import {MatPaginator} from '@angular/material/paginator';
import {Subscription} from 'rxjs';
import {ConfirmComponent} from '../shared/dialogs/confirm/confirm.component';
import {PushSponsorDialogComponent} from './dialogs/push-sponsor-dialog/push-sponsor-dialog.component';
import {PushSponsorService} from '../services/push-sponsor.service';
import {PushSponsor} from '../models/push-sponsor';


@Component({
    selector: 'app-push-sponsor',
    templateUrl: './push-sponsor.component.html',
    styleUrls: ['./push-sponsor.component.scss'],
    entryComponents: [
        PushSponsorDialogComponent,
        ConfirmComponent
    ]
})

export class PushSponsorComponent implements OnInit {

    private sub: Subscription;

    public dataSource: MatTableDataSource<PushSponsor>
    public displayedColumns: string[] = ['icon', 'date', 'time', 'sponsor', 'text', 'sent', 'edit', 'delete'];

    @ViewChild(MatPaginator, {static: true}) paginator: MatPaginator;

    constructor (
        private _pushSponsorService: PushSponsorService,
        private dialog: MatDialog,
        private snackBar: SnackBarIconService) {
    }

    ngOnInit () {
        this.loadPushSponsors()
    }

    ngOnDestroy () {
        if (this.sub)
            this.sub.unsubscribe();
    }

    loadPushSponsors () {
        this.sub = this._pushSponsorService.select()
            .subscribe((result) => {

                let array = result.map(item => {

                    let push = new PushSponsor();
                    push.id = item.payload.doc.id;

                    push.sponsor_id = item.payload.doc.data().sponsor_id;
                    push.sponsor_name = item.payload.doc.data().sponsor_name;

                    push.title = item.payload.doc.data().title;
                    push.text = item.payload.doc.data().text;
                    push.url = item.payload.doc.data().url;

                    push.time_send = item.payload.doc.data().time_send;
                    push.sent = item.payload.doc.data().sent;

                    if (item.payload.doc.data().date_create)
                        push.date_create = item.payload.doc.data().date_create;

                    if (item.payload.doc.data().date_send)
                        push.date_send = item.payload.doc.data().date_send;

                    return push;
                });

                this.dataSource = new MatTableDataSource(array);
                this.dataSource.paginator = this.paginator;
            },
                (error) => {
                    console.log(JSON.stringify(error))
                    this.snackBar.openSnackBar("Acesso negado", '', 'error');
                })
    }


    applyFilter (filterValue: string) {
        this.dataSource.filter = filterValue.trim().toLowerCase();

        if (this.dataSource.paginator) {
            this.dataSource.paginator.firstPage();
        }
    }

    openDialog (push) {

        let pushData: PushSponsor = new PushSponsor();

        if (push) {
            pushData = push;
        } else {
            pushData = new PushSponsor();
        }

        this.dialog.open(PushSponsorDialogComponent, {
            width: '800px',
            height: '600px',
            panelClass: 'custom-dialog-container',
            data: pushData
        });

    }

    delete (element) {
        let push_id = element.id
        let dialogRef = this.dialog.open(ConfirmComponent, {
            width: '350px',
            height: '270px',
            panelClass: 'custom-dialog-container',
            data: {title: "Confirme", message: element.title + "<br><br>Excluir este push?"}
        });
        dialogRef.afterClosed().subscribe(result => {
            if (result == "ok") {
                this._pushSponsorService.delete(push_id)
                    .then(() => {
                        this.snackBar.openSnackBar("Sucesso!", '', 'success')
                    })
                    .catch((error) => {console.log("delete push error: " + error.message)}
                    )
                    .finally(() => this.dialog.closeAll()
                    )
            }
        })
    }

}
